<template>
  <el-row :gutter="10">
    <el-col :span="8">
      <el-card v-loading="loading">
        <div slot="header" class="align-left">
          <span class="title">Artist and labels</span>
          <el-button
            type="primary"
            class="btn-main float-right mr10"
            icon="el-icon-plus"
            @click="openLabelForm()"
          >
            Add Artist/Label
          </el-button>
          <el-button
            type="primary"
            class="btn-main float-right mr10"
            icon="el-icon-search"
            @click="openFilterDialog"
          >
            Filter
          </el-button>
          <LabelForm />
          <FilterDialog />
          <LabelDeposit />
        </div>
        <LabelTable />
      </el-card>
    </el-col>
    <el-col :span="16">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Campaigns</p>
          <TrackForm />
          <TrackDeposit />
          <EditTrackTable />
        </div>
        <TrackTable />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import LabelForm from '../components/manage/label/Form'
import LabelDeposit from '../components/manage/label/Deposit'
import LabelTable from '../components/manage/label/Table'
import TrackForm from '../components/manage/track/Form'
import TrackDeposit from '../components/manage/track/Deposit'
import TrackTable from '../components/manage/track/Table'
import EditTrackTable from '../components/manage/track/EditDialog'
import FilterDialog from '../components/manage/label/Filter'
import axios from "@/plugins/axios";

export default {
  components: {
    LabelForm,
    LabelDeposit,
    LabelTable,
    TrackForm,
    TrackDeposit,
    TrackTable,
    EditTrackTable,
    FilterDialog
  },

  computed: {
    ...mapState('vcLabel', ['loading'])
  },

  methods: {
    ...mapMutations('vcLabel', ['setLabel', 'setLabelForm', 'setFilterDialog']),
    ...mapMutations('vcTrack', ['setTrack', 'setTrackForm', 'setYoutubeCategories']),

    openLabelForm() {
      this.setLabelForm(true)
      this.setLabel({})
    },

    openTrackForm() {
      this.setTrackForm(true)
      this.setTrack({})
    },
    openFilterDialog() {
      this.setFilterDialog(true)
    }
  },
  async created() {
    await axios.api.get('youtube/categories')
        .then(res => { this.setYoutubeCategories(res.data.data) })
  }
}
</script>
